import { useEffect } from 'react';
import { Modal as AntModal, notification } from 'antd';

import { usePatch } from 'hooks';
import { setAccountProductActive } from 'services/api';

const ToggleActive = ({ product, setModal, refresh }) => {
  const [{ res, err }, patch] = usePatch({
    url: setAccountProductActive(product.id),
  });

  useEffect(() => {
    if (res) {
      notification.success({
        message: product.isActive
          ? `Deactivated "${product.name}"`
          : `Reactivated "${product.name}"`,
      });
      setModal('');
      refresh();
    }
  }, [res, product, setModal, refresh]);

  useEffect(() => {
    if (err) {
      notification.error({
        message: 'Could not update product',
        description: err.message ?? 'Unexpected error',
      });
    }
  }, [err]);

  const action = product.isActive ? 'Deactivate' : 'Reactivate';

  return (
    <AntModal
      open
      title={`${action} Product`}
      onCancel={() => setModal('')}
      onOk={() => patch({ isActive: !product.isActive })}
      okText={action}
    >
      <div>
        Are you sure you want to {action.toLowerCase()} "{product.name}"?
      </div>
    </AntModal>
  );
};

export default ToggleActive;
